exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".synergi-logo {\n    position: fixed;\n    width: 6%;\n    left: 47%;\n    opacity: .75;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/git/SynergiPartners 7-Eleven Screening/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = main